import React, { useState, useEffect } from "react";

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("bot_cookies_accepted");
    if (!accepted) {
      const t = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("bot_cookies_accepted", "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-6 right-6 max-w-sm bg-[#3a2f1c] border border-[#5a4a2c] p-5 shadow-2xl z-50 fade-up">
      <h5 className="text-[#f5f1e8] font-semibold mb-2">This website uses cookies.</h5>
      <p className="text-sm text-[#d5c9a8] mb-4">
        We use cookies to analyze website traffic and optimize your website experience. By
        accepting our use of cookies, your data will be aggregated with all other user data.
      </p>
      <button
        onClick={accept}
        className="w-full bg-[#e8a13a] hover:bg-[#d18f28] text-[#0f0f10] font-semibold py-2 text-sm tracking-widest transition-colors"
      >
        ACCEPT
      </button>
    </div>
  );
};

export default CookieBanner;
